import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Footer = ({ compact = false }) => {
  const { t } = useTranslation();

  const links = [
    { to: '/guide', label: t('footer.guide'), testid: 'footer-link-guide' },
    { to: '/terms', label: t('footer.terms'), testid: 'footer-link-terms' },
    { to: '/privacy', label: t('footer.privacy'), testid: 'footer-link-privacy' },
    { to: '/contact', label: t('footer.contact'), testid: 'footer-link-contact' },
  ];

  if (compact) {
    return (
      <div className="mt-6 text-center space-y-2" data-testid="app-footer-compact">
        <nav className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
          {links.map((l, i) => (
            <span key={l.to} className="flex items-center gap-2">
              <Link
                to={l.to}
                className="text-[10px] text-muted-foreground hover:text-cyan-300 transition-colors duration-150"
                data-testid={l.testid}
              >
                {l.label}
              </Link>
              {i < links.length - 1 && (
                <span className="text-muted-foreground/40 text-[10px]">|</span>
              )}
            </span>
          ))}
        </nav>
        <p className="text-[10px] text-muted-foreground/70" data-testid="footer-copyright">
          {t('footer.copyright')}
        </p>
      </div>
    );
  }

  return (
    <footer className="border-t border-border bg-[hsl(210,18%,7%)]/70 mt-12" data-testid="app-footer">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-[11px] text-muted-foreground" data-testid="footer-copyright">
          {t('footer.copyright')}
        </p>
        <nav className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
          {links.map((l, i) => (
            <span key={l.to} className="flex items-center gap-2">
              <Link
                to={l.to}
                className="text-[11px] text-muted-foreground hover:text-cyan-300 transition-colors duration-150"
                data-testid={l.testid}
              >
                {l.label}
              </Link>
              {i < links.length - 1 && (
                <span className="text-muted-foreground/40 text-[10px]">|</span>
              )}
            </span>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
